export const ExchangeRateEnum = {
  CNY_TO_VND: 1,
};
